/**
 * @class {T.Form.TextArea}
 * @extends {T.Form.Base}
 * @param {T.Form.TextArea.Par|Object} par
 */
T.Form.TextArea = Class(
	/**
	 * @lends {T.Form.TextArea#}
	 */
	{
		__NAME: 'T.Form.TextArea',

		/**
		 * @param {T.Form.TextArea.Par|Object} par
		 * @constructs
		 */
		__construct: function(par){
			let attr = {
				placeholder: par.placeholder || ''
			};
			O2O(attr, par.attr || {});
			this.par = par;

			this.node = mkE({
				tag: 'div',
				className: 'textarea',
				els: [
					this._captionNode = mkE({
						tag: 'label',
						className: 'hidden'
					}),
					this._itemNode = mkE({
						tag: 'textarea',
						className: 'form-control',
						attr: attr,
						prop: {
							onchange: par.onChange || D.doNothing,
							oninput: this._onInput,
							onkeyup: par.onKeyUp || D.doNothing,
							onkeydown: par.onKeyDown || D.doNothing,
						}
					}),
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			if( par.className ){
				addClassName(this.node, par.className);
			}

			if( par.border ){
				addClassName(this.node, 'textarea-border');
			}

			if( par.grow ) {
				this._itemNode.rows = 1;
				let node = mkE({
					tag: 'div',
					className: 'textarea-grow',
					els: [
						this._itemNode
					]
				});
				D.insertAfter(node, this._captionNode);
			}

			this._par(par);
			this.value(par.value || null);
		},

		_onInput() {
			if( this.par.grow ) {
				this._itemNode.parentNode.dataset.growContent = this._itemNode.value;
			}
			if ( this.par.onInput ) {
				this.par.onInput();
			}
		},

		value: function(v){
			if( isset(v) ){
				this._itemNode.value = v;
			}
			return this._itemNode.value;
		},

		focus: function(){
			this._itemNode.focus();
		}
	},
	T.Form.Base
);

/**
 * @class {T.Form.TextArea.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.TextArea.Par = Class(
	/**
	 * @lends {T.Form.TextArea.Par#}
	 */
	{
		__NAME: 'T.Form.TextArea.Par',

		placeholder: '',
		prefix: null,
		suffix: null,
		value: null,
		attr: {},
		prop: {},
		onKeyUp: D.doNothing,
		onKeyDown: D.doNothing,
		onChange: D.doNothing,
		onInput: D.doNothing,
		className: '',
		border: false,
		grow: false
	},
	T.Form.Base.Par
);